import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "../../Atoms/Icons";
import { isNewJob } from "../../static/jobsHelpers";
import { getDepartmentLabel, getLocationLabel } from "../../static/filterOptions";

import { IoChevronForwardOutline } from "react-icons/io5";
import { BsArrowRightShort } from "react-icons/bs";


export default function RelatedJobCard({ job }) {
  return (
    <article className="related-job-card">
      <div className="flex flex-wrap gap-2 mb-3">
        <span className="badge-dept">{getDepartmentLabel(job.department)}</span>
        <span className="badge-type">{job.employmentTypeShort}</span>
        {isNewJob(job) && <span className="badge-new">New</span>}
      </div>

      <h3 className="text-base font-bold mb-2 brand-font">{job.title}</h3>

      <p className="flex items-center gap-1 text-sm text-[var(--vm-text-gray)] mb-3">
        <MapPin size={14} />
        {getLocationLabel(job.location)}
      </p>

      

      {/* <Link to={`/careers/${job.slug}`} className="btn-vm-morph" style={{ paddingRight: "1.1rem" }}>
        <span className="morph-icon" style={{ width: 36, height: 36 }}>
          <ArrowRight size={16} />
        </span>
        <span>View Details</span>
      </Link> */}
      <Link to={`/careers/${job.slug}`} className="text-gray-600">
  <button
    className="btn-new font-semibold relative flex justify-center items-center rounded-full pl-12 pr-6 font-poppins"
  >
    <span className="flex justify-center items-center">
      <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
      <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
    </span>
    View Details
  </button>
</Link>
    </article>
  );
}
